import { useEffect, useState } from 'react';
import { getPublicConfig, LeanportSwitches } from '../services/configService';

const OFF: LeanportSwitches = { adminOnlyConfig: false, generalAddressAdminOnly: false };

// Deployment switches do not change at runtime, so every component shares one
// /public-config request. A response without switches is not cached so a
// later mount retries.
let cached: LeanportSwitches | undefined;
let pending: Promise<LeanportSwitches | undefined> | undefined;

const loadSwitches = (): Promise<LeanportSwitches | undefined> => {
  pending ??= getPublicConfig().then((config) => {
    if (config.leanport) cached = config.leanport;
    else pending = undefined;
    return config.leanport;
  });
  return pending;
};

/** Leanport deployment switches from /public-config; both off until loaded. */
export const useLeanportSwitches = (): LeanportSwitches => {
  const [switches, setSwitches] = useState<LeanportSwitches>(cached ?? OFF);

  useEffect(() => {
    if (cached) return;
    let active = true;
    void loadSwitches().then((loaded) => {
      if (active && loaded) setSwitches(loaded);
    });
    return () => {
      active = false;
    };
  }, []);

  return switches;
};
